type Props =  {
  width?: number;
  height?: number;
}

export default function StethoscopeIcon({ width = 20, height = 20 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      aria-hidden="true"
      focusable="false"
    >
      <path fill="currentColor" d="M6.66732 2.5V4.16667H5.00065V7.5C5.00065 9.34167 6.49232 10.8333 8.33398 10.8333C10.1757 10.8333 11.6673 9.34167 11.6673 7.5V4.16667H10.0007V2.5H12.5007C12.9607 2.5 13.334 2.87333 13.334 3.33333V7.5C13.334 9.9775 11.5323 12.0333 9.16732 12.4308V13.75C9.16732 15.3608 10.4732 16.6667 12.084 16.6667C13.3315 16.6667 14.3965 15.8833 14.8132 14.7808C13.9406 14.3917 13.334 13.5167 13.334 12.5C13.334 11.1192 14.4532 10 15.834 10C17.2148 10 18.334 11.1192 18.334 12.5C18.334 13.6425 17.5673 14.6058 16.5206 14.9042C16.009 16.8767 14.2165 18.3333 12.084 18.3333C9.55232 18.3333 7.50065 16.2817 7.50065 13.75V12.4308C5.13565 12.0342 3.33398 9.9775 3.33398 7.5V3.33333C3.33398 2.87333 3.70732 2.5 4.16732 2.5H6.66732ZM15.834 11.6667C15.374 11.6667 15.0007 12.04 15.0007 12.5C15.0007 12.96 15.374 13.3333 15.834 13.3333C16.294 13.3333 16.6673 12.96 16.6673 12.5C16.6673 12.04 16.294 11.6667 15.834 11.6667Z" />
    </svg>
  )
}
